import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { VALIDATION_RULES } from "@/constants/ValidationRules";
import { Prop } from "vue-property-decorator";
import _ from "lodash";
import Snackbar from './Snackbar.vue';
let AddKidSchoolFormForm = class AddKidSchoolFormForm extends Vue {
    kidSchoolId = null;
    dataSource;
    dialog = false;
    errorMessage = '';
    submitting = false;
    hour;
    duration = 100;
    pricePerKid = 600;
    capacity = 15;
    isPremium = false;
    instructorsCount = 7;
    isPrepaidOnly = false;
    hourRules = [
        VALIDATION_RULES.REQUIRED,
    ];
    durationRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    pricePerKidRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    capacityRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    instructorsCountRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    maxCapacity = 20;
    created() {
        this.hour = { hour: 9, minute: 20 };
    }
    async open(school) {
        this.reset();
        await this.$nextTick();
        this.kidSchoolId = school?.id ?? null;
        this.capacity = school?.capacity ?? 15;
        this.hour = school ? `${school.hourFrom}:${school.minuteFrom < 10 ? `0${school.minuteFrom}` : school.minuteFrom}` : '09:20';
        this.duration = school?.duration ?? 100;
        this.pricePerKid = school?.pricePerKid ?? 600;
        this.isPremium = school?.isPremium ?? false;
        this.instructorsCount = school?.instructorMaxCount ?? 7;
        this.isPrepaidOnly = school?.isPrepaidOnly ?? false;
        this.dialog = true;
    }
    async submit() {
        if (this.submitting)
            return;
        if (this.hour === undefined) {
            return;
        }
        if (!this.$refs.form.validate()) {
            return;
        }
        this.submitting = true;
        try {
            const date = _.cloneDeep(this.dataSource.date).set({ hour: this.hour.split(':')[0], minute: this.hour.split(':')[1] });
            if (this.kidSchoolId) {
                await this.$store.dispatch('kidSchool/update', {
                    id: this.kidSchoolId,
                    capacity: this.capacity,
                    length: this.duration,
                    price: this.pricePerKid,
                    isPremium: this.isPremium,
                    instructorsCount: this.instructorsCount,
                    isPrepaidOnly: this.isPrepaidOnly,
                });
            }
            else {
                await this.$store.dispatch('kidSchool/store', {
                    capacity: this.capacity,
                    dateTime: date.toISOString(),
                    length: this.duration,
                    price: this.pricePerKid,
                    isPremium: this.isPremium,
                    instructorsCount: this.instructorsCount,
                    isPrepaidOnly: this.isPrepaidOnly,
                });
            }
            this.dialog = false;
            this.$emit('submit');
        }
        catch (e) {
            Snackbar.error(e instanceof Error ? e.message : 'Chyba při ukládání školky');
        }
        finally {
            this.submitting = false;
        }
    }
    cancel() {
        this.reset();
        this.dialog = false;
    }
    reset() {
        this.kidSchoolId = null;
        if (this.$refs.form) {
            this.$refs.form.reset();
        }
    }
    get dateString() {
        return this.dataSource.date.format("DD. MM. YYYY");
    }
    get isEditing() {
        return this.kidSchoolId !== null;
    }
};
__decorate([
    Prop({ required: true })
], AddKidSchoolFormForm.prototype, "dataSource", void 0);
AddKidSchoolFormForm = __decorate([
    Component
], AddKidSchoolFormForm);
export default AddKidSchoolFormForm;
